'use client';

import { useEffect, useState } from 'react';
import styles from '@//components/Footer/Footer.module.scss';

interface CookieConsentButtonProps {
  children: React.ReactNode;
  title?: string;
}

export const CookieConsentButton: React.FC<CookieConsentButtonProps> = ({ children, title }) => {
  const [isClient, setIsClient] = useState(false);
  const [isCookieScriptLoaded, setIsCookieScriptLoaded] = useState(false);

  useEffect(() => {
    setIsClient(true);

    const checkCookieScript = () => {
      if (window?.CookieScript?.instance) {
        setIsCookieScriptLoaded(true);
        return;
      }
      setTimeout(checkCookieScript, 100);
    };

    checkCookieScript();
  }, []);

  const handleClick = () => {
    if (window?.CookieScript?.instance?.show) {
      window.CookieScript.instance.show();
    }
  };

  if (!isClient || !isCookieScriptLoaded) {
    return null;
  }

  return (
    <button className={styles.cookieButton} onClick={handleClick} title={title}>
      {children}
    </button>
  );
};
